import { render, staticRenderFns } from "./StatisticsColumn.vue?vue&type=template&id=032a60d2&"
import script from "./StatisticsColumn.vue?vue&type=script&lang=js&"
export * from "./StatisticsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032a60d2')) {
      api.createRecord('032a60d2', component.options)
    } else {
      api.reload('032a60d2', component.options)
    }
    module.hot.accept("./StatisticsColumn.vue?vue&type=template&id=032a60d2&", function () {
      api.rerender('032a60d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/Page/StatisticsColumn.vue"
export default component.exports